'use client';
import { Box, Container, Heading } from '@chakra-ui/react';

import Image from '@/app/_components/Image';
import HomeHeroSlide1 from '@/app/_images/therighttochoose.webp';
import { getImageLink } from '@/services/link.service';
import { directusImageLoader } from '@/utils/loaders';

import Styles from './BannerSection.module.scss';

const HeroBanner = ({ title, banner }: { title?: string; banner?: string }) => {
  return (
    <>
      <Box
        className={Styles.heroBannerWrap}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'center'}
        flexDirection={'column'}
        height={{ base: 'auto', md: '300px' }}
      >
        <Box className={Styles.heroImageWrapper} width={'100%'}>
          <Image
            src={getImageLink(banner ?? '') ?? HomeHeroSlide1}
            loader={directusImageLoader}
            objectFit="cover"
            layout="fill"
            alt="after-sales background image"
            title="after-sales background image"
            className={Styles.heroImage}
          />
        </Box>
        <Container
          className={Styles.heroBannerContentWrapper}
          maxW={'1280'}
          width={'100%'}
          zIndex={1}
          paddingX={{ base: 6, '2xl': 0 }}
        >
          <Box className={Styles.heroBannerContent}>
            <Box
              className={Styles.headingElement}
              paddingY={{ base: 12, md: 0 }}
            >
              <Heading
                as="h1"
                className={Styles.titleLg}
                textAlign={'center'}
                color={'white'}
              >
                {title}
              </Heading>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default HeroBanner;
